// extracted by css-extract-rspack-plugin
export default {"card":"card-NDtP80","spinner":"spinner-dGxSWh","title":"title-GXJC89","count":"count-uUG4bF","track":"track-jCSuBh","fill":"fill-we3hgF"};